import type { AnalyzeAttemptDto } from "./generated/api-client";

/**
 * One-shot handoff: the sample-create flow starts analysis, then navigates to
 * Data Sources. DataSourcesTable takes this pending attempt and resumes the
 * existing poll/modal path without creating a second attempt.
 */
export type PendingSampleAnalyse = {
  datasourceId: string;
  attempt: AnalyzeAttemptDto;
};

let pending: PendingSampleAnalyse | null = null;

export function setPendingSampleAnalyse(
  next: PendingSampleAnalyse | null,
): void {
  pending = next;
}

/** Read and clear. Returns null when nothing is waiting. */
export function takePendingSampleAnalyse(): PendingSampleAnalyse | null {
  const current = pending;
  pending = null;
  return current;
}
